module.exports = __webpack_public_path__ + "static/media/art-sample-1.c560178a.png";